import { forwardRef, useImperativeHandle } from "react";

import { IFilterComp, IFilterParams } from "@ag-grid-community/core";

import useRefState from "@mapmycustomers/shared/util/hook/useRefState";
import useRerenderer from "@mapmycustomers/shared/util/hook/useRerenderer";

import AgGridFilterOperator from "@app/enum/AgGridFilterOperator";
import { NegativeTextCondition } from "@app/types/viewModel/agGridModel/AgGridFilterModel";

interface Props extends IFilterParams {}

// eslint-disable-next-line no-empty-pattern
const NegativeTextFilter = forwardRef<Partial<IFilterComp>, Props>(({}, ref) => {
  const forceRender = useRerenderer();
  const [operator, setOperator] = useRefState<AgGridFilterOperator>(
    AgGridFilterOperator.STARTS_WITH,
    forceRender
  );
  const [value, setValue] = useRefState("", forceRender);

  useImperativeHandle(
    ref,
    () => {
      return {
        doesFilterPass(): boolean {
          // TODO: complete me (only needed for the client-side filtering)
          return false;
        },

        getModel(): NegativeTextCondition | undefined {
          return {
            filter: value.current,
            filterType: "negativeTextFilter",
            type: operator.current,
          };
        },

        isFilterActive(): boolean {
          return value.current.trim().length > 0;
        },

        setModel(model: NegativeTextCondition | undefined) {
          if (model) {
            setOperator(model.type);
            setValue(model.filter ?? "");
          }
        },
      };
    },
    [operator, setOperator, setValue, value]
  );

  // We don't render anything, this is a just a filter file to let AgGrid support it
  return null;
});

export default NegativeTextFilter;
